import { mapState } from 'vuex';
import { AppState } from '@/vuex/store';
import { ScheduleRuleState } from '@/rule/vuex/store';
import { ScheduleRule } from '@/rule/models/ScheduleRule';
import { CustomerState } from '@/customer/vuex/store';
import { AccountState } from '@/common/models/Account';
import WxTemplate from '@/rule/models/WxTemplate';
import { DelayMode } from '../models/ScheduleDelay';

export default {
  computed: mapState({
    scheduleRuleState(state: AppState): ScheduleRuleState {
      return state.scheduleRuleState;
    },
    customerState(state: AppState): CustomerState {
      return state.customerState;
    },
    accountState(state: AppState): AccountState {
      return state.accountState;
    },
    scheduleRule(state: AppState): ScheduleRule {
      return state.scheduleRuleState.scheduleRule;
    },
    eventDelayMode(state: AppState): DelayMode | undefined {
      return state.scheduleRuleState && state.scheduleRuleState.eventDelayMode;
    },
    scheduleRules(state: AppState): ScheduleRule[] {
      return state.scheduleRuleState.scheduleRules;
    },
    wxTemplates(state: AppState): WxTemplate[] {
      return state.scheduleRuleState.wxTemplates;
    },
    wxTplTemplates(state: AppState): any[] {
      return state.scheduleRuleState.wxTplTemplates;
    },
    wxTplTemplateTip(state: AppState): boolean {
      return state.scheduleRuleState.wxTplTemplateTip;
    },
    trendsData(state: AppState): any[] {
      return state.scheduleRuleState.trendsData;
    },
    props(state: AppState): any[] {
      return state.customerState.props;
    },
  }),
};
